/**
 * Created by Gayratjon Rayimjonov on 5/25/2017.
 */
(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('StatsPerTime', StatsPerTime);

    StatsPerTime.$inject = ['$resource', 'DateUtils'];

    function StatsPerTime ($resource, DateUtils) {
        var resourceUrl =  'api/stats-per-time';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertDateTimeFromServer(data.registrationDate);
                    }
                    return data;
                }
            }
        });
    }
})();
